@if (companyName$ | async; as companyName) {
  <div class="company-name">{{ companyName }}</div>
}
<h2 color="primary">新規アカウント登録</h2>
@if (showSpinner) {
  <div class="spinner">
    <mat-spinner diameter="60"></mat-spinner>
  </div>
}
@if (changeForm) {
  <div class="login-container">
    <div class="attention">
      <span class="phrase">IDとパスワードは忘れないよう</span><span class="phrase">大切に管理してください！</span>
    </div>
    <form [formGroup]="changeForm">
      <div class="category-container">
        <div>
          <label>ID</label><mat-hint>　{{ Constant.msgIdInvalid }}</mat-hint>
        </div>
        <div>
          <input
            id="user_id"
            name="user_id"
            class="text-input"
            type="text"
            formControlName="user_id"
            [class.input-invalid]="changeForm.get('user_id')?.invalid && (changeForm.get('user_id')?.touched || changeForm.get('user_id')?.dirty)"
          />
        </div>
        @if (changeForm.get('user_id')?.invalid && (changeForm.get('user_id')?.touched || changeForm.get('user_id')?.dirty)) {
          <mat-error class="error-text">
            半角、8桁以上で入力してください。
          </mat-error>
        }
      </div>
      <div class="category-container">
        <div>
          <label>パスワード</label>
          <mat-hint>　{{ Constant.msgPassInvalid }}</mat-hint>
        </div>
        <div>
          <input
          class="text-input"
          type="password"
          formControlName="password" required
          [class.input-invalid]="changeForm.get('password')?.invalid && (changeForm.get('password')?.touched || changeForm.get('password')?.dirty)"
          />
        </div>
        @if (changeForm.get('password')?.invalid && (changeForm.get('password')?.touched || changeForm.get('password')?.dirty)) {
          <mat-error class="error-text">
            英字と数字の組み合わせ、8桁以上で入力してください。
          </mat-error>
        }
      </div>
      <div class="category-container">
        <div>
          <label>パスワード（確認）</label>
        </div>
        <div>
          <input class="text-input" type="password" formControlName="passwordConfirm" required />
        </div>
        <div class="password-error">
          @if (newPasswordConfirm.invalid && newPasswordConfirm.touched) {
            <mat-error class="error-text">
              パスワード（確認）を入力してください。
            </mat-error>
          }
        </div>
        <div class="password-error">
          @if (newPasswordConfirm.dirty && changeForm.errors) {
            <mat-error class="error-text">
              パスワードとパスワード（確認）が異なります。
            </mat-error>
          }
        </div>
      </div>
      <div class="category-container">
        <div class="label-row">
          <label>アカウント申請コメント	</label>
          <mat-hint align="end">
            <span class="length-hint" [class.red]="commentMaxLength">
              {{ changeForm.get('comment')?.value?.length || 0 }} / 100
            </span>
          </mat-hint>
        </div>
        <div>
          <div class="input">
            <mat-form-field appearance="outline" class="no-placeholder">
              <textarea matInput
                class="input-textarea"
                formControlName="comment"
                #comment
                maxlength="100"
                (keydown.enter)="onKeyDown($event)"
                (input)="onInput($event.target, 'commentMaxLength', 100)">
              </textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
      <div class="attention2">
        <span class="phrase">UNION NESTの</span><span class="phrase"><a (click)="onAgreement()">利用規約</a>および</span><span class="phrase"><a (click)="onPrivacy()">プライバシーポリシー</a>に</span><span class="phrase">同意のうえ、</span><br>
          <span class="phrase">「同意してアカウントを作成」を</span><span class="phrase">押してください。</span>
      </div>
      <div class="footer-container">
        <div class="signup-wrapper">
          <button type="button" (click)="onSignUp()" class="signUp-button" [disabled]="isSaving || changeForm.invalid">同意してアカウントを作成</button>
          @if (isSaving) {
            <mat-spinner diameter="28" class="spinner2"></mat-spinner>
          }
        </div>
        <div class="attention3">
          すでにアカウントをお持ちの方
        </div>
        <button type="button" (click)="onLogin()" class="login-btn">ログイン</button>
      </div>
      </form>
    </div>
  }
